import Dialog from './Dialog'

export { Dialog }
export default Dialog



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js